import type { FeedbackCollectorConfig } from '@/types/feedbackCollector';
import type { WootricConfig } from '@/types/wootric';

let cachedFeedbackCollectorConfig: FeedbackCollectorConfig | null = null;
let cachedWootricConfig: WootricConfig | null = null;

const defaultWootricConfig: WootricConfig = {
  wootricDomain: '',
  productionAccountId: '',
  testAccountId: '',
  product: '',
  productReportingCode: '',
  customerName: '',
  linkUrl: '',
  linkWord: '',
  blacklistedDomains: [],
};

export const configService = {
  async getFeedbackCollectorConfig(): Promise<FeedbackCollectorConfig> {
    if (cachedFeedbackCollectorConfig) {
      return cachedFeedbackCollectorConfig;
    }

    const accountToken = import.meta.env.VITE_FEEDBACK_COLLECTOR_ACCOUNT_TOKEN ?? '8ysj675gwbvabokyqa55bxlm9cd4f8d6';

    const defaultFeedbackCollectorConfig: FeedbackCollectorConfig = {
      baseUrl: 'https://mfe.workspace.accessacloud.com/registry/evo-feature-feedback-collector/1/',
      accountToken,
      product: 'ERP Credit Control',
    };

    try {
      const response = await fetch('/config/feedbackCollector.config.json');
      if (!response.ok) {
        console.warn('Feedback collector config not found, using defaults');
        return defaultFeedbackCollectorConfig;
      }

      const configFromFile = await response.json();
      cachedFeedbackCollectorConfig = {
        ...configFromFile,
        accountToken,
      };
      return cachedFeedbackCollectorConfig!;
    } catch (error) {
      console.error('Failed to load feedback collector config:', error);
      return defaultFeedbackCollectorConfig;
    }
  },

  clearCache(): void {
    cachedFeedbackCollectorConfig = null;
  },

  async getWootricConfig(): Promise<WootricConfig> {
    if (cachedWootricConfig) {
      return cachedWootricConfig;
    }

    try {
      const response = await fetch('/config/wootric.config.json');
      if (!response.ok) {
        console.warn('Wootric config not found, using defaults');
        return defaultWootricConfig;
      }

      cachedWootricConfig = await response.json();
      return cachedWootricConfig!;
    } catch (error) {
      console.error('Failed to load Wootric config:', error);
      return defaultWootricConfig;
    }
  },

  clearWootricCache(): void {
    cachedWootricConfig = null;
  },
};
